var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, customElement, property } from 'lit-element';
import '@material/mwc-dialog';
import '@material/mwc-button/mwc-button';
let MaterialDialog = class MaterialDialog extends LitElement {
    render() {
        return html `
      <style>mwc-dialog { --mdc-theme-primary: #00376c; }</style>
      <mwc-dialog title="${this.title}" open>
        <div>${this.content}</div>
        <mwc-button dialogAction="ok" slot="primaryAction">Ok</mwc-button>
      </mwc-dialog>
    `;
    }
};
__decorate([
    property()
], MaterialDialog.prototype, "title", void 0);
__decorate([
    property()
], MaterialDialog.prototype, "content", void 0);
MaterialDialog = __decorate([
    customElement('material-dialog')
], MaterialDialog);
